import MenuConst from "./MenuConst.ts";

export class ZapleczeMenu {
    static readonly NONE:number           = MenuConst.NONE;
    static readonly WYLOGUJ:number        = MenuConst.MAIN;
    static readonly OBSLUGA_LEADOW:number = MenuConst.MAIN + 1;
    static readonly MAPA_DOBRA:number     = MenuConst.MAIN + 2;
    static readonly FIRMA:number          = MenuConst.MAIN + 3;
    static readonly ADMIN:number          = MenuConst.MAIN + 4;

    static readonly WYLOGUJ_STR          = "Wyloguj";
    static readonly OBSLUGA_LEADOW_STR   = "Obsługa leadów";
    static readonly MAPA_DOBRA_STR       = "Mapa dobra";
    static readonly FIRMA_STR            = "Profil firmy"
    static readonly ADMIN_STR            = "Admin";

    get OBSLUGA_LEADOW():number    { return ZapleczeMenu.OBSLUGA_LEADOW;}
    get MAPA_DOBRA():number        { return ZapleczeMenu.MAPA_DOBRA;}
    get PROFIL_FIRMY():number      { return ZapleczeMenu.FIRMA;}
    get ADMIN():number             { return ZapleczeMenu.ADMIN;}
    get WYLOGUJ():number           { return ZapleczeMenu.WYLOGUJ;}

    // TODO private
    misot():string[] {
        let a = [];
        a[ZapleczeMenu.OBSLUGA_LEADOW]  = ZapleczeMenu.OBSLUGA_LEADOW_STR;
        a[ZapleczeMenu.MAPA_DOBRA]      = ZapleczeMenu.MAPA_DOBRA_STR;
        a[ZapleczeMenu.ADMIN]           = ZapleczeMenu.ADMIN_STR;
        a[ZapleczeMenu.WYLOGUJ]         = ZapleczeMenu.WYLOGUJ_STR;
        return a;
    };

    // TODO private
    provider():string[] {
        let a = [];
        a[ZapleczeMenu.OBSLUGA_LEADOW]  = ZapleczeMenu.OBSLUGA_LEADOW_STR;
        a[ZapleczeMenu.MAPA_DOBRA]      = ZapleczeMenu.MAPA_DOBRA_STR;
        a[ZapleczeMenu.FIRMA]           = ZapleczeMenu.FIRMA_STR;
        a[ZapleczeMenu.WYLOGUJ]         = ZapleczeMenu.WYLOGUJ_STR;
        return a;
    };

    constructor(isProvider:boolean = false) {
        if (isProvider) {
            this.list = this.provider();
        } else {
            this.list = this.misot();
        }
    }

    public menu():Array<string> {
        return this.list;
    }

    private list:Array<string>;
}
